import { get } from 'lodash';

export const getSelectedSurveyType = state => {
  return get(state, 'entities.notifications.selectedSurveyType', 'LaborBCSubstantiation');
};

export const getFormDataForSelectedSurveyType = state => {
  const selectedSurveyType = getSelectedSurveyType(state);
  const allData = get(state, 'entities.notifications.notificationFormData.data', {});

  if (!allData) return {};

  if (allData.LaborBCSubstantiation || allData.LaborProjectSubstantiation) {
    return get(allData, selectedSurveyType, {});
  }

  return allData || {};
};

export const getCombinedApplicableOptions = state => {
  const allData = get(state, 'entities.notifications.notificationFormData.data', {});

  if (!allData) return [];

  if (allData.LaborBCSubstantiation || allData.LaborProjectSubstantiation) {
    const bcData = get(allData, 'LaborBCSubstantiation.applicable', []);
    const projectData = get(allData, 'LaborProjectSubstantiation.applicable', []);
    const combined = [...bcData, ...projectData];
    return combined.filter(
      (item, index, self) => index === self.findIndex(t => t.value === item.value),
    );
  }

  return get(allData, 'applicable', []);
};
